var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8899 2.14777C37.7967 1.95023 37.6493 1.78326 37.4649 1.66632C37.2804 1.54938 37.0665 1.48729 36.8481 1.4873H1.15155C0.933193 1.48736 0.719347 1.54949 0.534945 1.66644C0.350543 1.78338 0.203183 1.95034 0.110042 2.14784C0.0169013 2.34534 -0.0181819 2.56525 0.00888212 2.78192C0.0359462 2.9986 0.124043 3.20312 0.262901 3.37164L13.9852 20.0151V35.3619C13.9852 35.5579 14.0352 35.7506 14.1305 35.9218C14.2258 36.0931 14.3631 36.2372 14.5297 36.3405C14.6962 36.4438 14.8863 36.5029 15.082 36.5123C15.2778 36.5216 15.4727 36.4808 15.6482 36.3938L23.3582 32.5725C23.5502 32.4773 23.7119 32.3304 23.825 32.1484C23.9381 31.9664 23.9981 31.7564 23.9984 31.5421L24.0134 20.0156L37.7365 3.37149C37.8755 3.20306 37.9637 2.99858 37.9909 2.7819C38.018 2.56522 37.983 2.34529 37.8899 2.14777ZM21.9738 18.8688C21.8041 19.0746 21.7111 19.3331 21.7108 19.5999L21.6961 30.8256L16.2887 33.5057V19.6014C16.2888 19.3341 16.1958 19.075 16.0257 18.8688L3.59377 3.79055H34.4058L21.9738 18.8688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterHome);
export default __webpack_public_path__ + "static/media/Filter-home.aa2742217e70003fb612a3af7c7b5539.svg";
export { ForwardRef as ReactComponent };